// Game profiles shown on the page. The relay's allowed list (docs/81 section 3.1, KV `profiles`)
// is the authority; until GET /v1/profiles exists we fall back to the v1 list below.

import { Mode, ModeId } from "./gblink";
import { Family, RELAY_ORIGIN } from "./relay";

export interface Profile {
  id: string;
  label: string;
  detail: string;
  games: string;
  enabled: boolean;
  note?: string;
  // Only for profiles the page can run today.
  family?: Family;
  mode?: ModeId;
  variant?: number;
  minFirmware?: [number, number, number];
  inGameHint?: string;
}

export const FALLBACK_PROFILES: Profile[] = [
  {
    id: "gen3-cable-trade",
    label: "Trade",
    detail: "Link cable",
    games: "Ruby · Sapphire · Emerald · FireRed · LeafGreen",
    enabled: true,
    family: "gba-cable",
    mode: Mode.GbaLink,
    inGameHint:
      "Go upstairs in any Pokémon Center, talk to the attendant on the left and choose the Trade Center.",
  },
  {
    id: "gen3-rfu-trade",
    label: "Trade",
    detail: "Wireless adapter",
    games: "FireRed · LeafGreen · Emerald",
    enabled: true,
    family: "gba-rfu",
    mode: Mode.WirelessAdapter,
    variant: 0,
    minFirmware: [2, 2, 6],
    inGameHint:
      "Go upstairs in any Pokémon Center, enter the Union Room (or the wireless Trade Center) and trade with your friend.",
  },
  { id: "gen3-battle", label: "Battle", detail: "Gen 3", games: "Colosseum battles", enabled: false, note: "Coming soon" },
  { id: "gen3-record-mix", label: "Record Mixing", detail: "Gen 3", games: "Ruby · Sapphire · Emerald", enabled: false, note: "Coming soon" },
  { id: "gen3-blender", label: "Berry Blender", detail: "Gen 3", games: "Ruby · Sapphire · Emerald", enabled: false, note: "Coming soon" },
  { id: "gen12-trade", label: "Trade", detail: "Game Boy / Color", games: "Red · Blue · Yellow · Gold · Silver · Crystal", enabled: false, note: "Coming soon" },
];

/** Server switches override the fallback list; profiles the page can't run stay disabled. */
export async function loadProfiles(): Promise<Profile[]> {
  try {
    const res = await fetch(`${RELAY_ORIGIN}/v1/profiles`);
    if (!res.ok) return FALLBACK_PROFILES;
    const remote: Array<{ id: string; enabled: boolean; note?: string }> = await res.json();
    const byId = new Map(remote.map((r) => [r.id, r]));
    return FALLBACK_PROFILES.map((p) => {
      const r = byId.get(p.id);
      const runnable = p.family !== undefined;
      return {
        ...p,
        enabled: runnable && (r ? r.enabled : false),
        note: r?.note ?? (runnable && r?.enabled ? undefined : (p.note ?? "Unavailable")),
      };
    });
  } catch {
    return FALLBACK_PROFILES;
  }
}
